import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { TenantProvider } from './contexts/TenantContext';
import App from './App';
import './index.css';
import './i18n/config'; // Initialiser i18n
import { IS_TOUCH_DEVICE } from './utils/touchDevice';

// Le zoom est bloqué dans index.html (`maximum-scale=1, user-scalable=no`) pour
// qu'un pincement accidentel ne dérègle pas une caisse en service. Sur un
// APPAREIL TACTILE, cette interdiction empêche aussi de reculer pour voir un
// écran conçu pour 1024 px et plus : sur iPhone, la grille de produits et le
// menu « ⋯ Plus » restent hors d'atteinte (signalé le 09/08/2026). On rend donc
// le zoom aux téléphones et tablettes ; les Mac mini gardent l'interdiction.
if (IS_TOUCH_DEVICE) {
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute('content', 'width=device-width, initial-scale=1.0, viewport-fit=cover');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <TenantProvider>
        <App />
      </TenantProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// Remove inline loading screen once React has mounted
const loader = document.getElementById('app-loading');
if (loader) loader.remove();
